import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
const links = [{
  name: 'Wirkung',
  href: '#wirkung'
}, {
  name: 'Inhaltsstoffe',
  href: '#inhaltsstoffe'
}, {
  name: 'Erfahrungen',
  href: '#erfahrungen'
}, {
  name: 'FAQ',
  href: '#faq'
}];
export function Header() {
  const [isOpen, setIsOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 h-[72px] flex items-center ${isScrolled || isOpen ? 'bg-white/90 backdrop-blur-md border-b border-slate-200 shadow-sm' : 'bg-transparent'}`} data-id="element-120">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full" data-id="element-121">
        <div className="flex items-center justify-between" data-id="element-122">
          {/* Logo */}
          <a href="#" className="flex items-center gap-2 group" data-id="element-123">
            <div className="text-2xl font-serif font-bold text-slate-900 tracking-tight" data-id="element-124">
              Uro<span className="text-brand-500" data-id="element-125">Nacht</span>
            </div>
          </a>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-8" data-id="element-126">
            {links.map(link => <a key={link.name} href={link.href} className="text-sm font-medium text-slate-600 hover:text-brand-600 transition-colors" data-id="element-127">
                {link.name}
              </a>)}
          </nav>

          {/* Desktop CTA */}
          <div className="hidden md:flex items-center" data-id="element-128">
            <a href="#pricing" className="inline-flex items-center justify-center px-6 py-2.5 text-sm font-bold text-white bg-slate-900 rounded-lg hover:bg-slate-800 transition-all duration-300 shadow-lg shadow-slate-900/10 hover:shadow-slate-900/20 hover:-translate-y-0.5" data-id="element-129">
              Jetzt bestellen
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button onClick={() => setIsOpen(!isOpen)} className="md:hidden p-2 text-slate-600 hover:text-slate-900 transition-colors" aria-label="Menu" data-id="element-130">
            {isOpen ? <X className="w-6 h-6" data-id="element-131" /> : <Menu className="w-6 h-6" data-id="element-132" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu — CSS transition instead of framer-motion */}
      <div className={`md:hidden absolute top-[72px] left-0 right-0 bg-white border-b border-slate-200 overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-[400px] opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-133">
        <div className="px-4 py-6 space-y-4" data-id="element-134">
          {links.map(link => <a key={link.name} href={link.href} onClick={() => setIsOpen(false)} className="block text-lg font-medium text-slate-900 hover:text-brand-600 transition-colors" data-id="element-135">
              {link.name}
            </a>)}
          <div className="pt-4 border-t border-slate-100" data-id="element-136">
            <a href="#pricing" onClick={() => setIsOpen(false)} className="flex items-center justify-center w-full px-6 py-3 text-base font-bold text-white bg-slate-900 rounded-lg hover:bg-slate-800 transition-colors shadow-md" data-id="element-137">
              Jetzt bestellen
            </a>
          </div>
        </div>
      </div>
    </header>;
}